import React from 'react';
import { Container, Grow, Grid } from "@material-ui/core";
import useStyles from "./styles";
import Feature from '../Feature/Feature';
import { DOCX_MIME_TYPE, DOC_MIME_TYPE, PPTX_MIME_TYPE, PPT_MIME_TYPE, ODT_MIME_TYPE, PNG_MIME_TYPE, JPEG_MIME_TYPE, PDF_MIME_TYPE } from "../../../constants/FileFormatAndMimeTypes";

const CompressorHomePage = () => {
    const classes = useStyles();
    const compressorHomePageFeatures = [
        { uniqueId:'1', title: "Pdf Compressor", inputType: ".pdf", acceptKey: PDF_MIME_TYPE, content: "Compress your PDF document to smaller size", buttonText: "Proceed to pdf compressor"},
        //{ uniqueId:'2', title: "Pptx Compressor", inputType: ".pptx", acceptKey: PPTX_MIME_TYPE, content: "Compress your MS Powerpoint Presentation document of .pptx type to smaller size", buttonText: "Proceed to pptx compressor"},
        //{ uniqueId:'3', title: "Ppt Compressor", inputType: ".ppt", acceptKey: PPT_MIME_TYPE, content: "Compress your MS Powerpoint Presentation document of .ppt type to smaller size", buttonText: "Proceed to ppt compressor"},
        { uniqueId:'4', title: "Png Compressor", inputType: ".png", acceptKey: PNG_MIME_TYPE, content: "Compress your PNG image file to smaller size", buttonText: "Proceed to png compressor"},
        { uniqueId:'5', title: "Jpeg/Jpg Compressor", inputType: ".jpeg", acceptKey: JPEG_MIME_TYPE, content: "Compress your JPEG/JPG image file to smaller size", buttonText: "Proceed to jpeg/jpg compressor"}
    ];

    return (
        <Grow in>
            <Container>
                <Grid className={classes.mainContainer} container justify="space-between" alignItems="stretch" spacing={3}>
                    {compressorHomePageFeatures.map((feature) => (
                        <Grid key={feature.uniqueId} item xs={12} sm={6}>
                            <Feature feature={feature} />
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Grow>
    )
}

export default CompressorHomePage
